import React, { useEffect, useState } from 'react';
import useAPI from '../../../api';
import Dialog from '..';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import AddEditEventWidget from './AddEditEventWidget';
import { useAtomValue } from 'jotai';
import { userDataAtom } from '../../../Atoms';
import useModuleFlag from '../../../Hooks/useModuleFlag';

const AppointmentDialog = function AppointmentDialog({
  open,
  onClose,
  selectedBranch,
  isOperator = false,
  onSubmit,
  hideCustomerField = false,
  title,
  defaultData = null,
  fullScreen = false,
}) {
  const API = useAPI();
  const userData = useAtomValue(userDataAtom);
  // Whether this installation lets an operator be named as the appointment's
  // assignee. Read at render, not inside the effect below: it is a hook now, and
  // reactive - the old reader was a synchronous global, so a value arriving after
  // first paint produced no re-render.
  const canAssignAppointee = useModuleFlag('APPOINTMENT_ASSIGNEE_FEATURE');
  const [operators, setOperators] = useState([]);
  const selfOperator = [
    {
      label: `${userData?.name} ${userData?.surname}`,
      value: userData?.id,
    },
  ];

  useEffect(() => {
    if (open && !isOperator && selectedBranch) {
      API.getBranchUsersByRole(
        selectedBranch.id,
        ['OPERATOR', 'SUPERVISOR', 'ADMIN'],
        (result) => {
          if (result && result.length > 0)
            setOperators(
              result.map(({ id, name, surname }) => ({
                label: `${name} ${surname}`,
                value: id,
              }))
            );
          else setOperators(selfOperator);
        },
        () => {
          setOperators(selfOperator);
        }
      );
    } else {
      if (canAssignAppointee)
        //if is operator and the feature is available
        setOperators(selfOperator);
      else setOperators([]);
    }
  }, [open, isOperator]);

  return (
    <Dialog
      id="appointment-dialog"
      title={title}
      icon={<CalendarMonthOutlinedIcon />}
      open={open}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={onSubmit}
      width="md"
      fullWidth
      fullScreen={fullScreen}
      form
      dividers
    >
      <AddEditEventWidget
        event={defaultData}
        hideCustomerField={hideCustomerField}
        selectedBranch={selectedBranch}
        operators={operators}
      />
    </Dialog>
  );
};

export default AppointmentDialog;
